import {
  vBoolean,
  vFallback,
  vInt,
  vMaxValue,
  vMinValue,
  vObject,
  vOptional,
  vOptionalDef,
  type vOutput,
  vPicklist,
  vPipe,
  vString,
  vStringToNumber,
} from '../validation/index.ts'
import {
  type AddressType,
  addressTypes,
  type CompanyAddressBase,
  type GeocodedAddressFields,
} from './address.ts'
import { workflows } from './common.ts'
import type {
  FlatbedHandlingType,
  LocationAccessorialDTO,
} from './location-accessorial.ts'
import type { ShipType } from './ship-type.ts'

const addressLookupContexts = [
  ...workflows,
  'tl-customs-broker',
  'ltl-customs-broker',
  'address-book',
  'customs-broker',
] as const

export const addressLookupTypes = [...addressTypes, 'all'] as const
export type AddressLookupType = (typeof addressLookupTypes)[number]
export const addressLookupSchema = vObject({
  includeAtlas: vOptional(vBoolean()),
  includeAddressBook: vOptionalDef(vBoolean(), true),
  search: vOptional(vString()),
  skip: vFallback(vPipe(vStringToNumber(), vInt(), vMinValue(0)), 0),
  limit: vFallback(vPipe(vStringToNumber(), vInt(), vMaxValue(50)), 50),
  type: vOptional(vPicklist(addressLookupTypes)),
  context: vOptional(vPicklist(addressLookupContexts)),
  onlyAccountLocations: vOptional(vBoolean()),
})

export type AddressLookupDTO = vOutput<typeof addressLookupSchema>
export type AddressLookupContext = (typeof addressLookupContexts)[number]

export interface AddressLookupResult
  extends CompanyAddressBase,
    GeocodedAddressFields {
  _id?: string
  accountId?: string
  accessorials?: LocationAccessorialDTO[]
  mappedAccessorials?: {
    ltl: LocationAccessorialDTO[]
    parcel: LocationAccessorialDTO[]
    truckload: LocationAccessorialDTO[]
  }
  acceptability?: number
  dockHoursStart: string
  dockHoursEnd: string
  contactName?: string
  contactEmail?: string
  contactPhone?: string
  contactPhoneExt?: string
  flatbedHandlingType?: FlatbedHandlingType
  isAccountLocation?: boolean
  accountLocationId?: string
  instructions?: string
  internalNotes?: string
  shipType?: ShipType | ''
  bolFollowers?: string[]
  sendBOL?: boolean
  type?: AddressType
}

export const cityLookupSchema = vObject({
  city: vString(),
})

export type CityLookupDTO = vOutput<typeof cityLookupSchema>
